var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEdit = function SvgEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0312 9.875C13 9.90625 13 9.96875 13 10V14.5C13 14.7812 12.75 15 12.5 15H1.5C1.21875 15 1 14.7812 1 14.5V3.5C1 3.25 1.21875 3 1.5 3H10C10.0312 3 10.0938 3 10.125 2.96875L10.75 2.34375C10.875 2.21875 10.7812 2 10.625 2H1.5C0.65625 2 0 2.6875 0 3.5V14.5C0 15.3438 0.65625 16 1.5 16H12.5C13.3125 16 14 15.3438 14 14.5V9.375C14 9.21875 13.7812 9.125 13.6562 9.25L13.0312 9.875ZM17.5938 3.90625C18.125 3.375 18.125 2.5625 17.5938 2.03125L15.9688 0.40625C15.4375 -0.125 14.625 -0.125 14.0938 0.40625L4.34375 10.1562L4 13.2812C3.9375 13.7188 4.28125 14.0625 4.71875 14L7.84375 13.6562L17.5938 3.90625ZM14.6875 5.40625L7.375 12.7188L5.03125 12.9688L5.28125 10.625L12.5938 3.3125L14.6875 5.40625ZM16.9062 2.75C17.0312 2.875 17.0312 3.0625 16.9062 3.1875L15.375 4.6875L13.3125 2.625L14.8125 1.09375C14.9375 0.96875 15.125 1 15.25 1.09375L16.9062 2.75Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit.c091f6a9.svg";
export { ForwardRef as ReactComponent };